import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { Pill } from '@m/alchemy-ui/Pill';
import { ToggleButton } from '@m/alchemy-ui/ToggleButton';
import { borderRadius, color, typeStyle, units } from '@m/alchemy-ui/theme';
import { BulletIcon } from '@m/alchemy-ui/icons/BulletIcon';

export const Title = styled.h1`
  ${typeStyle('dataL')};
  line-height: 60px;
`;
export const Background = styled.div`
  background-color: #ebedf0;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: -100;
`;
export const AssignmentsContainer = styled.main`
  width: 90%;
  margin: auto;
  [data-testid='all-archived-assignments-actions'] span,
  [data-testid='all-assignments-actions'] span {
    padding-right: 14px;
  }
`;

export const StyledStatusPill = styled(Pill)`
  ${typeStyle('labelL')};
  color: ${({ palette }) => color('base', { palette })};
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 1px;
  padding: 0 ${units(0.5)};
  min-width: ${units(2)};
`;

export const PeopleCount = styled.span`
  ${typeStyle('subHeaderS')};
  &.enabled {
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
  }
`;

export const ProgressPercent = styled.span`
  ${typeStyle('headerM')};
  font-weight: 700;
`;

export const ProgressInfo = styled.span`
  ${typeStyle('actionM')};
  .emoji-mart-emoji span {
    cursor: default;
  }
`;

export const AssignmentDescription = styled.span`
  ${typeStyle('bodyM')};

  a {
    color: ${color('typeLink')};
  }
`;

export const EmployeeName = styled.span`
  ${typeStyle('bodyM')};
  margin-bottom: ${units(0.5)};
`;

export const EmployeeProgress = styled.li`
  [data-testid='progress-percentage'] {
    ${typeStyle('actionM')};
  }
  .text-link {
    ${typeStyle('actionM')};
    margin: auto;
  }
  border-bottom: solid 1px rgba(0, 0, 0, 0.08);
`;

export const StyledToggleButton = styled(ToggleButton)`
  height: 36px;
`;

export const ReturnLink = styled(Link)`
  display: flex;
  align-items: flex-start;
  gap: ${units(1)};
  font-weight: 700;
  color: ${color('typeLink')};
  p {
    ${typeStyle('actionM')};
  }
`;

export const EmployeeActivityWrapper = styled.div`
  margin-top: ${units(1)};
  ${typeStyle('labelL')};
  color: ${color('typeMeta')};
`;

export const GroupWrapper = styled.div`
  padding: ${units(2.75)} 0 ${units(0.75)};

  label {
    margin-left: ${units(7)};
    color: ${color('typeMeta')};
    font-size: 9px;
    font-style: normal;
    font-weight: 800;
    line-height: 20px;
    letter-spacing: 1px;
    text-transform: uppercase;
  }
`;

export const SummaryWrapper = styled.div`
  margin: ${units(1)} 0;
  padding: ${units(1)} ${units(2)};
  ${typeStyle('labelL')};
  color: ${color('typeBody')};

  border-radius: ${borderRadius('large')};
  border: 1px solid ${color('line')};
  background: ${color('hint')};
`;

export const ReviewButtonHolder = styled.div`
  min-width: ${units(10)};
`;

export const ChangeIndicator = styled(BulletIcon)`
  position: absolute;
  right: ${units(2)};
  top: ${units(2)};
`;
